module.exports = "<header class=\"portlet-header\">\n  <h2 class=\"portlet-title\">{{'infoTitle' | i18n}}</h2>\n</header>\n<portlet-body>\n  <div class=\"portlet-body padding-body scrollable\" dc-scrollbar>\n    <div class=\"padding-body scrollable\" ng-bind-html=\"infoMessage | i18n\" dc-scrollbar>\n  </div>\n  <div class=\"portlet-footer\">\n    <button class=\"btn btn-primary\" ng-click=\"$close();\" data-i18n=\"common.buttons.ok\"></button>\n  </div>\n</portlet-body>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/dc-ui/dc-modal/infoDialog.tpl.html
// module id = 481
// module chunks = 12